import {
  ASSET_FETCH_FAILED,
  DELETE_ACCOUNT_FAILED,
  DELETE_ACCOUNT_START,
  DELETE_ACCOUNT_SUCCESS,
  FETCH_ALL_USER_LIST_FAILED,
  FETCH_ALL_USER_LIST_START,
  FETCH_ALL_USER_LIST_SUCCESS,
  FETCH_MANAGER_ASSET_CATEGORY_SUCCESS,
  FETCH_MANAGER_USERS_FAILED,
  FETCH_MANAGER_USERS_START,
  FETCH_MANAGER_USERS_SUCCESS,
  MANAGER_ASSET_FETCH_START,
  MANAGER_ASSET_FETCH_SUCCESS,
  MANAGER_ASSET_UPDATE_START,
  MANAGER_ASSET_UPDATE_SUCCESS,
  MANAGER_ASSET_UPLOAD_FAILED,
  MANAGER_ASSET_UPLOAD_START,
  MANAGER_ASSET_UPLOAD_SUCCESS,
  DOWNGRADE_ACCOUNT_START,
  DOWNGRADE_ACCOUNT_SUCCESS,
  DOWNGRADE_ACCOUNT_FAILED,
  MANAGER_BULK_ASSET_UPLOAD_START,
  MANAGER_BULK_ASSET_UPLOAD_SUCCESS,
  MANAGER_BULK_ASSET_UPLOAD_FAILED,
  GET_PRO_ONCE_DEALS_START,
  GET_PRO_ONCE_DEALS_SUCCESS,
  GET_PRO_ONCE_DEALS_FAILED,
  UPDATE_PROMO_CODE_STATUS_START,
  UPDATE_PROMO_CODE_STATUS_SUCCESS,
  UPDATE_PROMO_CODE_STATUS_FAILED,
  MANAGER_TEMPLATE_SETTING_FETCH_START,
  MANAGER_TEMPLATE_SETTING_SUCCESS,
  MANAGER_TEMPLATE_SETTING_FAILED,
  MANAGER_TEMPLATE_SETTING_UPDATE_START,
  MANAGER_TEMPLATE_SETTING_UPDATE_SUCCESS,
  MANAGER_TEMPLATE_SETTING_UPDATE_FAILED,
  FETCH_ASSET_LIST_START,
  FETCH_ASSET_LIST_SUCCESS,
  FETCH_ASSET_LIST_FAILED,
  CREATE_TEMPLATE_NEW_TAG_START,
  CREATE_TEMPLATE_NEW_TAG_SUCCESS,
  CREATE_TEMPLATE_NEW_TAG_FAILED,
  CREATE_WIDGET_NEW_TAG_START,
  CREATE_WIDGET_NEW_TAG_SUCCESS,
  CREATE_WIDGET_NEW_TAG_FAILED,
  FETCH_TEMPLATE_NEW_TAG_START,
  FETCH_TEMPLATE_NEW_TAG_SUCCESS,
  FETCH_TEMPLATE_NEW_TAG_FAILED,
  FETCH_WIDGET_NEW_TAG_START,
  FETCH_WIDGET_NEW_TAG_SUCCESS, 
  FETCH_WIDGET_NEW_TAG_FAILED,
  FETCH_TEMPLATE_GROUP_CATEGORY_START,
  FETCH_TEMPLATE_GROUP_CATEGORY_SUCCESS,
  FETCH_TEMPLATE_GROUP_CATEGORY_FAILED,
  MANAGER_UNPUBLISH_DOCUMENT_START,
  MANAGER_UNPUBLISH_DOCUMENT_SUCCESS,
  MANAGER_UNPUBLISH_DOCUMENT_FAILED,
  MANAGER_USAGE_DETAILS_START,
  MANAGER_USAGE_DETAILS_SUCCESS,
  MANAGER_USAGE_DETAILS_FAILED,
  FETCH_MANAGER_MEMBERS_PROFILES_LIST_START,
  FETCH_MANAGER_MEMBERS_PROFILES_LIST_SUCCESS,
  FETCH_MANAGER_MEMBERS_PROFILES_LIST_FAILED,
  FETCH_MANAGER_MEMBERS_PROFILE_START,
  FETCH_MANAGER_MEMBERS_PROFILE_SUCCESS,
  FETCH_MANAGER_MEMBERS_PROFILE_FAILED,
  FETCH_MANAGER_MEMBERS_LIST_START,
  FETCH_MANAGER_MEMBERS_LIST_SUCCESS,
  FETCH_MANAGER_MEMBERS_LIST_FAILED,
  FETCH_MANAGER_MEMBERS_START,
  FETCH_MANAGER_MEMBERS_SUCCESS,
  FETCH_MANAGER_MEMBERS_FAILED,
  CREATE_MANAGER_MEMBER_START,
  CREATE_MANAGER_MEMBER_SUCCESS,
  CREATE_MANAGER_MEMBER_FAILED,
  DELETE_MANAGER_MEMBER_START, 
  DELETE_MANAGER_MEMBER_SUCCESS,
  DELETE_MANAGER_MEMBER_FAILED,
  MANAGER_AI_DESIGN_LAYOUT_CATEGORIES_FETCH_START,
  MANAGER_AI_DESIGN_LAYOUT_CATEGORIES_FETCH_SUCCESS,
  MANAGER_AI_DESIGN_LAYOUT_CATEGORIES_FETCH_FAILED,
  MANAGER_AI_DESIGN_CATEGORIES_UPDATE_SUCCESS,
  MANAGER_AI_DESIGN_CATEGORIES_UPDATE_START,
  MANAGER_AI_DESIGN_CATEGORIES_UPDATE_FAILED,
  POPULAR_IDEAS_DOCUMENT_TYPE_START,
  POPULAR_IDEAS_DOCUMENT_TYPE_SUCCESS,
  POPULAR_IDEAS_DOCUMENT_TYPE_FAILED,
  GET_POPULAR_IDEAS_LIST_START,
  GET_POPULAR_IDEAS_LIST_SUCCESS,
  GET_POPULAR_IDEAS_LIST_FAILED,
  CREATE_POPULAR_IDEAS_START,
  CREATE_POPULAR_IDEAS_SUCCESS,
  CREATE_POPULAR_IDEAS_FAILED,
  UPDATE_POPULAR_IDEAS_START,
  UPDATE_POPULAR_IDEAS_SUCCESS,
  UPDATE_POPULAR_IDEAS_FAILED
} from "../actions/actionTypes";

export const managerReducer = (originalState = {}, action) => {
  const state = {
    ...originalState,
    type: action.type,
    flashMessage: null,
    status: action?.error?.response?.status ?? null,
  };

  switch (action.type) {
    case MANAGER_ASSET_FETCH_START:
      return { ...state, loading: true };

    case MANAGER_ASSET_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        assetList: action.assetLists.data,
        total: action.assetLists.total_count,
        keywordsProcessed: action.assetLists.keywords_updated_count,
        type: action.assetLists.asset_type,
        flashMessage: null,
      };

    case ASSET_FETCH_FAILED:
      return { ...state, loading: false };

    case MANAGER_ASSET_UPLOAD_START:
      return { ...state, loading: true, uploaded: null };

    case MANAGER_ASSET_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        uploaded: true,
        assetList: null,
        flashMessage: { type: "success", message: "Asset successfully uploaded" },
      };

    case MANAGER_ASSET_UPDATE_START:
      return { ...state, loading: action.reload ? true : false, uploaded: null };

    case MANAGER_ASSET_UPDATE_SUCCESS:
      if (action.reload) {
        return {
          ...state,
          loading: false,
          uploaded: true,
          assetList: null,
          flashMessage: { type: "success", message: "Asset successfully updated" },
        };
      }
      return {
        ...state,
        loading: false,
        uploaded: true,
        flashMessage: { type: "success", message: "Asset successfully updated" },
      };

    case MANAGER_ASSET_UPLOAD_FAILED:
      return { ...state, loading: false };

    case FETCH_MANAGER_ASSET_CATEGORY_SUCCESS:
      return { ...state, categories: { ...state.categories, [action.data.asset_type]: action.data.data } };

    case DELETE_ACCOUNT_START:
      return { ...state, loading: true, deleted: null };

    case DELETE_ACCOUNT_SUCCESS:
      return { ...state, loading: false, deleted: true };

    case DELETE_ACCOUNT_FAILED:
      return { ...state, loading: false, deleted: false };

    case DOWNGRADE_ACCOUNT_START:
      return { ...state, loading: true, downgraded: null };

    case DOWNGRADE_ACCOUNT_SUCCESS:
      return { ...state, loading: false, downgraded: true };

    case DOWNGRADE_ACCOUNT_FAILED:
      return { ...state, loading: false, downgraded: false };

    case FETCH_MANAGER_USERS_START:
      return { ...state, loading: true };

    case FETCH_MANAGER_USERS_SUCCESS:
      return { ...state, loading: false, ...action.data };

    case FETCH_MANAGER_USERS_FAILED:
      return { ...state, loading: false };

    case FETCH_ALL_USER_LIST_START:
      return { ...state, fetchLoading: true };

    case FETCH_ALL_USER_LIST_SUCCESS:
      return { ...state, fetchLoading: false, allUserDatas: action.data.users };

    case FETCH_ALL_USER_LIST_FAILED:
      return { ...state, fetchLoading: false };

    case MANAGER_BULK_ASSET_UPLOAD_START:
      return { ...state, loading: true, bulkUploaded: null };

    case MANAGER_BULK_ASSET_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        bulkUploaded: true,
        assetList: null,
        flashMessage: { type: "success", message: "Asset successfully uploaded" },
      };
    case MANAGER_BULK_ASSET_UPLOAD_FAILED:
      return { ...state, loading: false };
    
    case GET_PRO_ONCE_DEALS_START:
      return { ...state, loading: true };

    case GET_PRO_ONCE_DEALS_SUCCESS:
      return { ...state, loading: false, ...action.data };

    case GET_PRO_ONCE_DEALS_FAILED:
      return { ...state, loading: false };
    
    case UPDATE_PROMO_CODE_STATUS_START:
      return { ...state, loading: true };

    case UPDATE_PROMO_CODE_STATUS_SUCCESS:
      return { ...state, loading: false, promoData: action.data };

    case UPDATE_PROMO_CODE_STATUS_FAILED:
      return { ...state, loading: false, promoData: action.error.response.data };
      
    case MANAGER_TEMPLATE_SETTING_FETCH_START:
      return { ...state, loading: true };
  
    case MANAGER_TEMPLATE_SETTING_SUCCESS:
      if (action?.settingType == "types")
        return {
          ...state,
          loading: false,
          template_setting_types: action.settingsData.template_types,
          total_type: action.settingsData.total_count,
          flashMessage: null,
        };
      else if (action?.settingType == "categories")
        return {
          ...state,
          loading: false,
          template_setting_categories: action.settingsData.template_categories,
          total_category: action.settingsData.total_count,
          flashMessage: null,
      };  
  
    case MANAGER_TEMPLATE_SETTING_FAILED:
      return { ...state, loading: false };

    case MANAGER_TEMPLATE_SETTING_UPDATE_START:
      return { ...state, isLoading: true, settingUpdated: null};
  
    case MANAGER_TEMPLATE_SETTING_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        settingUpdated: true,
        [action.slug === "types" ? "template_setting_types" : "template_setting_categories"]: null,
        flashMessage: { type: "success", message: "Successfully updated" },
      };
  
    case MANAGER_TEMPLATE_SETTING_UPDATE_FAILED:
      return { ...state, isLoading: false };

    case FETCH_ASSET_LIST_START:
      return { ...state, isLoading: false};
  
    case FETCH_ASSET_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        [action.data.data.key] : action.data.categories
      };
  
    case FETCH_ASSET_LIST_FAILED:
      return { ...state, isLoading: false };

    case FETCH_TEMPLATE_NEW_TAG_START:
      return { ...state, isLoading: true};
  
    case FETCH_TEMPLATE_NEW_TAG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        templates : action.data.data
      };
  
    case FETCH_TEMPLATE_NEW_TAG_FAILED:
      return { ...state, isLoading: false };

    case FETCH_WIDGET_NEW_TAG_START:
      return { ...state, isLoading: true};
  
    case FETCH_WIDGET_NEW_TAG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        widgets : action.data.data
      };
  
    case FETCH_WIDGET_NEW_TAG_FAILED:
      return { ...state, isLoading: false };

    case CREATE_TEMPLATE_NEW_TAG_START:
      return { ...state, isLoading: false};
  
    case CREATE_TEMPLATE_NEW_TAG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        newTagTemplate : action.data
      };
  
    case CREATE_TEMPLATE_NEW_TAG_FAILED:
      return { ...state, isLoading: false };

    case CREATE_WIDGET_NEW_TAG_START:
      return { ...state, isLoading: false};
  
    case CREATE_WIDGET_NEW_TAG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        newTagWidget : action.data
      };
  
    case CREATE_WIDGET_NEW_TAG_FAILED:
      return { ...state, isLoading: false };

    case FETCH_TEMPLATE_GROUP_CATEGORY_START:
      return { ...state, isLoading: false};
  
    case FETCH_TEMPLATE_GROUP_CATEGORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        templateGroupCategory : action.data
      };
  
    case FETCH_TEMPLATE_GROUP_CATEGORY_FAILED:
      return { ...state, isLoading: false };

    case MANAGER_UNPUBLISH_DOCUMENT_START:
      return { ...state, isLoading: true, unpublishDoc : null };
  
    case MANAGER_UNPUBLISH_DOCUMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        unpublishDoc : action.data.message
      };
  
    case MANAGER_UNPUBLISH_DOCUMENT_FAILED:
      return { ...state, isLoading: false, unpublishDoc : action.error.response.data.message };

    case MANAGER_USAGE_DETAILS_START:
      return { ...state, isLoading: true};
  
    case MANAGER_USAGE_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        usageAllDetails : action.data
      };
  
    case MANAGER_USAGE_DETAILS_FAILED:
      return { ...state, isLoading: false };

     case FETCH_MANAGER_MEMBERS_PROFILES_LIST_START:
      return { ...state, managerProfileLoading: true };

    case FETCH_MANAGER_MEMBERS_PROFILES_LIST_SUCCESS:
      return { ...state, managerProfileLoading: false, managerProfileList : action.data.profiles };

    case FETCH_MANAGER_MEMBERS_PROFILES_LIST_FAILED:
      return { ...state, managerProfileLoading: false };

    case FETCH_MANAGER_MEMBERS_PROFILE_START:
      return { ...state, loading: true };

    case FETCH_MANAGER_MEMBERS_PROFILE_SUCCESS:
      return { ...state, loading: false, ...action.data };

    case FETCH_MANAGER_MEMBERS_PROFILE_FAILED:
      return { ...state, loading: false };

    case FETCH_MANAGER_MEMBERS_LIST_START:
      return { ...state, addedManagerUserListLoading: true };

    case FETCH_MANAGER_MEMBERS_LIST_SUCCESS:
      return { ...state, addedManagerUserListLoading: false, addedManagerUserList : action.data.data, addedManagerUserTotal : action.data.total };

    case FETCH_MANAGER_MEMBERS_LIST_FAILED:
      return { ...state, addedManagerUserListLoading: false };

    case FETCH_MANAGER_MEMBERS_START:
      return { ...state, loading: true };

    case FETCH_MANAGER_MEMBERS_SUCCESS:
      return { ...state, loading: false, ...action.data };

    case FETCH_MANAGER_MEMBERS_FAILED:
      return { ...state, loading: false };

    case CREATE_MANAGER_MEMBER_START:
      return { ...state, loading: true };

    case CREATE_MANAGER_MEMBER_SUCCESS:
      return { ...state, loading: false, ...action.data };

    case CREATE_MANAGER_MEMBER_FAILED:
      return { ...state, loading: false };

    case DELETE_MANAGER_MEMBER_START:
      return { ...state, loading: true };

    case DELETE_MANAGER_MEMBER_SUCCESS:
      return { ...state, loading: false, ...action.data };

    case DELETE_MANAGER_MEMBER_FAILED:
      return { ...state, loading: false };

    case MANAGER_AI_DESIGN_LAYOUT_CATEGORIES_FETCH_START:
      return { ...state, loading: true };
  
    case MANAGER_AI_DESIGN_LAYOUT_CATEGORIES_FETCH_SUCCESS:
        return {
          ...state,
          loading: false,
          layout_category_list: action.data.data,
          total_category: action.data.total,
          flashMessage: null,
      };  
  
    case MANAGER_AI_DESIGN_LAYOUT_CATEGORIES_FETCH_FAILED:
      return { ...state, loading: false };

    case MANAGER_AI_DESIGN_CATEGORIES_UPDATE_START:
      return { ...state, isLoading: true, aiCategoriesUpdated: null};
  
    case MANAGER_AI_DESIGN_CATEGORIES_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        aiCategoriesUpdated: true,
        layout_category_list: null,
        flashMessage: { type: "success", message: "Successfully updated" },
      };
  
    case MANAGER_AI_DESIGN_CATEGORIES_UPDATE_FAILED:
      return { ...state, isLoading: false };

    case POPULAR_IDEAS_DOCUMENT_TYPE_START:
      return { ...state };

    case POPULAR_IDEAS_DOCUMENT_TYPE_SUCCESS:
      return { ...state, popularIdeasDocumentType : action.data.data };

    case POPULAR_IDEAS_DOCUMENT_TYPE_FAILED:
      return { ...state };

    case GET_POPULAR_IDEAS_LIST_START:
      return { ...state, popularIdeaListLoading: true };

    case GET_POPULAR_IDEAS_LIST_SUCCESS:
      return { ...state, popularIdeaListLoading: false, popularIdeasList : action.data.data , totalPopularIdeas : action.data.total};

    case GET_POPULAR_IDEAS_LIST_FAILED:
      return { ...state, popularIdeaListLoading: false };

    case CREATE_POPULAR_IDEAS_START:
      return { ...state, creatingPopularIdeasLoading: true };

    case CREATE_POPULAR_IDEAS_SUCCESS:
      return { ...state, creatingPopularIdeasLoading: false, createdPopularIdeas : action.data };

    case CREATE_POPULAR_IDEAS_FAILED:
      return { ...state, creatingPopularIdeasLoading: false };

    case UPDATE_POPULAR_IDEAS_START:
      return { ...state, creatingPopularIdeasLoading: true };

    case UPDATE_POPULAR_IDEAS_SUCCESS:
      return { ...state, creatingPopularIdeasLoading: false, updatedNewPopularIdeas : action.data };

    case UPDATE_POPULAR_IDEAS_FAILED:
      return { ...state, creatingPopularIdeasLoading: false };
  
    default:
      return state;
  }
};
